import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("hauller") !== null && localStorage.getItem("hauller") !== undefined && localStorage.getItem("hauller") !== "") {

    data = JSON.parse(localStorage.getItem("hauller"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        gethauller: (state, action) => {
            localStorage.setItem("hauller", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { seedetails, home, gethauller } = Insider.actions;
export default Insider.reducer;